<template>

  <v-chip
    v-if="showId"
    :text="id"
    density="compact"
  />

</template>

<script setup lang="ts">

import { computed } from 'vue'

import PermissionsService from '../services/PermissionsService'
import PreferencesService from '../services/PreferencesService'

interface Props {
  id: number
}

defineProps<Props>()

const showId = computed<boolean>(() => {
    return PreferencesService.preferences.showIds && PermissionsService.can('seeids')
})

</script>
